import "./cardProjectsFront.scss";

type TCardProjectsFront = {
  image: string;
};
export const CardProjectsFront = ({ image }: TCardProjectsFront) => {
  return <img src={image} alt='image-projects' className='card-front-image' />;
};
